import { useEffect, useState } from 'preact/hooks'

import { CONSENT_BANNER_ATTRIBUTE, DOM_ROOT_ID, SUPPORT_LANG } from '@configs'

export default function useI18NText(key) {
  const [text, setText] = useState({})

  useEffect(() => {
    const element = document.getElementById(DOM_ROOT_ID)
    if (!element) {
      return
    }

    const lang = element.getAttribute(CONSENT_BANNER_ATTRIBUTE.LANG)
    if (lang && lang === SUPPORT_LANG.EN) {
      import('@configs/i18n/en').then((obj) => {
        setText(obj.default[key])
      })

      return
    }

    import('@configs/i18n/th').then((obj) => {
      setText(obj.default[key])
    })
  }, [])

  return text
}
